import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
}
export function CountdownTimer({
  initialHours = 22,
  initialMinutes = 47,
  initialSeconds = 25
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev; // Stop at 0
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-2xl font-bold font-sans" data-id="element-70">
      <div className="flex flex-col items-center" data-id="element-71">
        <div className="bg-white text-primary px-3 py-2 rounded-lg shadow-sm min-w-[3rem] text-center" data-id="element-72">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-[10px] uppercase tracking-wider mt-1 opacity-80" data-id="element-73">
          Horas
        </span>
      </div>
      <span className="text-white pb-5" data-id="element-74">:</span>
      <div className="flex flex-col items-center" data-id="element-75">
        <div className="bg-white text-primary px-3 py-2 rounded-lg shadow-sm min-w-[3rem] text-center" data-id="element-76">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-[10px] uppercase tracking-wider mt-1 opacity-80" data-id="element-77">
          Minutos
        </span>
      </div>
      <span className="text-white pb-5" data-id="element-78">:</span>
      <div className="flex flex-col items-center" data-id="element-79">
        <div className="bg-white text-primary px-3 py-2 rounded-lg shadow-sm min-w-[3rem] text-center" data-id="element-80">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-[10px] uppercase tracking-wider mt-1 opacity-80" data-id="element-81">
          Segundos
        </span>
      </div>
    </div>;
}